"use client";

/**
 * Favoritos 2.7 — grid de guardados + aviso de stock.
 */

import Link from "next/link";

import { BottomNav, HeaderLogo } from "@/components/app/chrome";
import { useApp } from "@/components/app/proveedor";
import { ProductoCard } from "@/components/app/producto-card";
import type { ProductoApp } from "@/components/app/tipos";

export function FavoritosCliente({ productos }: { productos: ProductoApp[] }) {
  const { favoritos } = useApp();
  const guardados = productos.filter((p) => favoritos[p.slug]);

  return (
    <>
      <HeaderLogo />
      <main className="anim-bz-in min-h-(--alto-app) px-[17px] pt-[119px] pb-[62px]">
        <div className="pt-[26px] pb-[30px]">
          <h1 className="font-app text-xl font-semibold">TUS FAVORITOS</h1>

          {guardados.length > 0 ? (
            <div className="mt-[18px] grid grid-cols-2 gap-4">
              {guardados.map((p) => (
                <ProductoCard key={p.slug} producto={p} />
              ))}
            </div>
          ) : (
            <p className="mt-5 text-sm leading-[21px] text-tinta/60">
              Todavía no guardas ningún boot. Toca el corazón de cualquier
              tarjeta del <Link href="/productos" className="text-verde underline">catálogo</Link> para
              verlo aquí.
            </p>
          )}

          <div className="mt-[26px] rounded-3xl bg-humo p-5">
            <div className="font-app text-base font-semibold">
              Los favoritos se agotan rápido
            </div>
            <p className="mt-1.5 text-[13px] leading-[19px] text-tinta/65">
              Te avisamos por WhatsApp cuando vuelva stock de tus guardados.
            </p>
          </div>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
